var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.connection.originFiberID
      ? _c(
          "div",
          {
            staticClass: "objectDiv connectionDiv left",
            on: {
              contextmenu: function($event) {
                return _vm.openMenu(
                  $event,
                  _vm.connection.originFiberID,
                  "origin"
                )
              }
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.connection.originLabel))]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "fiberType",
                staticStyle: { "min-width": "40px" }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.connection.originFiberLogicalType
                      ? _vm.connection.originFiberLogicalType
                      : "-"
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fiberDiv" },
              [
                _c("div", {
                  staticClass: "connectionIndicator",
                  style: { "background-color": _vm.connection.originTubeColor }
                }),
                _vm._v(" "),
                _vm.connection.originFiberComment
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "div",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "fiberColour",
                                          style: {
                                            "background-color":
                                              _vm.connection.originFiberColor
                                          }
                                        },
                                        "div",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3499061706
                        )
                      },
                      [
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.connection.originFiberComment))
                        ])
                      ]
                    )
                  : _c("div", {
                      staticClass: "fiberColour",
                      style: {
                        "background-color": _vm.connection.originFiberColor
                      }
                    }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.connection.originIdentificators))
                ])
              ],
              1
            )
          ]
        )
      : _c(
          "div",
          {
            staticClass: "objectDiv connectionDiv",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.openTubeForm("origin", _vm.connection.connectionId)
              }
            }
          },
          [
            _c("span", { staticStyle: { "font-size": "x-large" } }, [
              _vm._v("+")
            ])
          ]
        ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "connectorDiv connectionDiv",
        staticStyle: { "text-transform": "capitalize" }
      },
      [_vm._v(_vm._s(_vm.connection.mode))]
    ),
    _vm._v(" "),
    _vm.connection.destinationFiberID
      ? _c(
          "div",
          {
            staticClass: "objectDiv connectionDiv right",
            on: {
              contextmenu: function($event) {
                return _vm.openMenu(
                  $event,
                  _vm.connection.destinationFiberID,
                  "destination"
                )
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "fiberDiv" },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.connection.destinationIdentificators))
                ]),
                _vm._v(" "),
                _vm.connection.destinationFiberComment
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "div",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "fiberColour",
                                          style: {
                                            "background-color":
                                              _vm.connection
                                                .destinationFiberColor
                                          }
                                        },
                                        "div",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3551423554
                        )
                      },
                      [
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.connection.destinationFiberComment))
                        ])
                      ]
                    )
                  : _c("div", {
                      staticClass: "fiberColour",
                      style: {
                        "background-color": _vm.connection.destinationFiberColor
                      }
                    }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "connectionIndicator",
                  style: {
                    "background-color": _vm.connection.destinationTubeColor
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "fiberType",
                staticStyle: { "min-width": "40px" }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.connection.destinationFiberLogicalType
                      ? _vm.connection.destinationFiberLogicalType
                      : "-"
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.connection.destinationLabel))])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "objectDiv connectionDiv",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.openTubeForm(
                  "destination",
                  _vm.connection.connectionId
                )
              }
            }
          },
          [
            _c("span", { staticStyle: { "font-size": "x-large" } }, [
              _vm._v("+")
            ])
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-798f4c5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798f4c5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/Connection.vue
// module id = null
// module chunks = 